export enum EditStage {
    Draft = 'draft',
    Review = 'review',
    Published = 'published',
    Outdated = 'outdated',
}
